var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":_vm.right,"left":_vm.left,"bottom":_vm.bottom,"top":_vm.top,"max-width":_vm.maxWidth,"color":_vm.background},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({class:_vm.css,attrs:{"color":_vm.colour,"size":_vm.size}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_vm._t("default",function(){return [_vm._v("UofT Index")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }